/*
 * Copyright (C) 2023 Airfordable, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import 'whatwg-fetch';

import { useEffect, useState } from 'react';

import { createTinyLink } from './createTinyLink';
import { createDynamicDownloadLink } from './oneLink';
import { usePostHogUserId } from './usePostHogUserId';

/**
 * Creates a shortlink for downloading the app.
 *
 * @param postHogUserId The PostHog user ID.
 * @returns The shortlink.
 */
async function createDownloadShortLink(
  postHogUserId: string | undefined
): Promise<string | undefined> {
  const link = createDynamicDownloadLink(postHogUserId);
  if (!link) return undefined;
  return createTinyLink(link);
}

/** Generates a dynamic download link. */
export const useDynamicDownloadLink = (): string | undefined => {
  const [dynamicLink, setDynamicLink] = useState<string | undefined>(undefined);

  const postHogUserId = usePostHogUserId();

  useEffect(() => {
    createDownloadShortLink(postHogUserId).then((link) => {
      setDynamicLink(link);
    });
  }, [postHogUserId]);

  return dynamicLink;
};
